import { withInstall } from '@tw-element/utils'

import Backtop from './src/backtop.vue'

export const TwBacktop = withInstall(Backtop)
export default TwBacktop

export * from './src/backtop'
